import CreateAdministrator from '@modules/admin/administrators/Admin.Create'
import AdministratorIndex from '@modules/admin/administrators/Admin.Index'
import AdministratorShow from '@modules/admin/administrators/Admin.Show'
import UpdateAdministrator from '@modules/admin/administrators/Admin.Update'
import CreateCompany from '@modules/admin/companies/Company.Create'
import DerivationCreate from '@modules/admin/derivations/Derivation.Create'

import DerivationIndex from '@modules/admin/derivations/Derivation.Index'
import DerivationShow from '@modules/admin/derivations/Derivation.Show'
import DerivationUpdate from '@modules/admin/derivations/Derivation.Update'

import Monitoring from '@modules/admin/monitoring/monitoring'
import CreateProfessional from '@modules/admin/professionals/Professional.Create'
import UpdateProfessional from '@modules/admin/professionals/Professional.Update'
import ProfessionalIndex from './admin/professionals/Professional.Index'
import ProfessionalShowContainer from './admin/professionals/Professional.Show'
import RelationsIndex from './admin/relations/Relations.Index'
import GroupsIndex from './admin/groups/Groups.Index'
import GroupsProfessionalUpdate from './admin/groups/GroupsProfessional.Update'

import ContentIndex from './admin/feed/Content.Index'
import ContentUpdate from './admin/feed/Content.Update'
import FeedIndex from './admin/feed/Feed.Update'

import RoomShow2 from '@modules/admin/rooms/Room.Show'
import { Schedules } from '@modules/admin/schedules2/Schedules'
import PageForbidden from '@modules/admin/screens/PageForbidden'
import SentenceCreate from '@modules/admin/sentence/Sentence.Create'

import SentenceIndex from '@modules/admin/sentence/Sentence.Index'
import SentenceShow from '@modules/admin/sentence/Sentence.Show'
import SentenceUpdate from '@modules/admin/sentence/Sentence.Update'

import AuthenticationGate from '@modules/auth/Authentication.Gate'
import React from 'react'
import { Route, Switch } from 'react-router'

import Dashboard from './admin/Admin'
import AnalyticsCustomer from './admin/analytics/Analytics.ActiveCustomer'

import AnalyticsConsultas from './admin/analytics/Analytics.Consultations'
import AnalyticsInstallations from './admin/analytics/Analytics.Downloads'
import AnalyticsNps from './admin/analytics/Analytics.NPS'
import AnalyticsQos from './admin/analytics/Analytics.qos'
import AnalyticsResponse from './admin/analytics/Analytics.ResponseTime'
import AnalyticsUsage from './admin/analytics/Analytics.UserAccess'

import CompaniesIndex from './admin/companies/Company.Index'
import UpdateCompany from './admin/companies/Company.Update'
import CompanySpecialities from '@modules/admin/companies/Company.Specialities'
import CustomerIndexContainer from './admin/customers/Customer.Index'
import CustomerShowContainer from './admin/customers/Customer.Show'
import CustomerCreateContainer from './admin/customers/Customer.Create'

import RoomIndex from './admin/rooms/Room.Index'

import ScheduleIndex from './admin/schedules-legacy/containers/ScheduleIndexContainer'
import AdminWelcome from './admin/screens/AdminWelcome'
import PageNotFound from './admin/screens/PageNotFound'

import SpecialityIndexContainer from './admin/speciality/Speciality.Index'
import PasswordForgotten from './auth/Password.Forgotten'
import PasswordReset from './auth/Password.Reset'

import PrivateRoute from './auth/PrivateRoute'
import Login from './auth/SignIn'
import LogOut from './auth/SignOut'

import Chat from './chat/Chat'
import ChangePassword from './auth/Password.Change'
import Horarios from '@modules/admin/schedules'
import SpecialityEdit from '@modules/admin/speciality/Speciality.Edit'
import NewGroupsUserUpdate from '@modules/admin/groups/NewGroupsUser.Update'
import SsoSignIn_MD from './auth/SsoSignIn_MD'
import SsoSignIn_MD_App from './auth/SsoSignIn_MD_App'
import { FEATURE_FLAG_MODULE_CUSTOMER_LIST } from '@/environment/environment.constant'

export const Routes = () => (
  <Switch>
    <Route exact path="/" component={Login} />
    <Route exact path="/logout" component={LogOut} />
    <Route exact path="/password/reset" component={PasswordForgotten} />
    <Route path="/password/reset/:token" component={PasswordReset} />
    <Route path="/sso-login" component={SsoSignIn_MD} />
    <Route path="/sso-login-app" component={SsoSignIn_MD_App} />
    <AuthenticationGate>
      <Switch>
        <Route exact path="/chat" component={Chat} />
        <Route path="/chat/:roomId" component={Chat} />
        <Route path="/password" exact component={ChangePassword} />
        <Dashboard>
          <Switch>
            <Route exact path="/admin" component={AdminWelcome} />

            <PrivateRoute
              adminType="company"
              permission="customer.view"
              exact
              path="/customers"
              component={FEATURE_FLAG_MODULE_CUSTOMER_LIST ? CustomerIndexContainer : AdminWelcome}
            />
            <PrivateRoute
              adminType="company"
              permission="customer.view"
              path="/customers/create"
              exact
              component={CustomerCreateContainer}
            />
            <PrivateRoute
              adminType="company"
              permission="customer.view"
              path="/customers/:hash"
              exact
              component={CustomerShowContainer}
            />

            <Route permission="index-room" exact path="/room" component={RoomIndex} />

            <Route
              permission="show-room"
              path="/room/:roomId"
              // TODO:https://stackoverflow.com/questions/32961014/how-to-unmount-a-component-on-route-change
              // TODO:kind of followed the solution proposed here, forced component to reMount giving it different keys
              render={(props) => <RoomShow2 key={props.match.params.roomId} {...props} />}
            />

            <Route permission="professionals.view" path="/schedules" component={ScheduleIndex} />

            <Route exact path="/professional" component={ProfessionalIndex} />

            <Route path="/professional/:id/schedule" component={Horarios} />

            <Route permission="professionals.manage" path="/professional/update/:id" component={UpdateProfessional} />
            <PrivateRoute
              adminType="provider"
              permission="professionals.manage"
              exact
              path="/professional/create"
              component={CreateProfessional}
            />

            <PrivateRoute
              adminType="provider"
              permission="professionals.view"
              path="/professional/:id"
              component={ProfessionalShowContainer}
            />
            {import.meta.env.VITE_REACT_APP_ENV === 'DEVELOPMENT' && (
              <PrivateRoute adminType="PaaS" path="/relations" component={RelationsIndex} />
            )}

            <PrivateRoute exact path="/groups" component={GroupsIndex} />
            <PrivateRoute path="/groups/professional/update/:id" component={GroupsProfessionalUpdate} />
            <PrivateRoute exact path="/groups/professional/create" component={GroupsProfessionalUpdate} />
            <PrivateRoute path="/groups/user/update/:id" component={NewGroupsUserUpdate} />
            <PrivateRoute exact path="/groups/user/create" component={NewGroupsUserUpdate} />

            <PrivateRoute exact path="/content" component={ContentIndex} />
            <PrivateRoute exact path="/content/create" component={ContentUpdate} />
            <PrivateRoute path="/content/update/:id" component={ContentUpdate} />

            <PrivateRoute exact path="/feed/create" component={FeedIndex} />
            <PrivateRoute path="/feed/update/:id" component={FeedIndex} />

            <PrivateRoute adminType="super-admin" exact path="/administrator" component={AdministratorIndex} />

            <PrivateRoute path="/administrator/create" adminType="super-admin" exact component={CreateAdministrator} />

            <PrivateRoute adminType="super-admin" path="/administrator/update/:id" component={UpdateAdministrator} />

            <PrivateRoute adminType="super-admin" path="/administrator/:id" component={AdministratorShow} />

            <PrivateRoute adminType="super-admin" exact path="/speciality" component={SpecialityIndexContainer} />
            <PrivateRoute adminType="super-admin" exact path="/speciality/create" component={SpecialityEdit} />
            <PrivateRoute adminType="super-admin" path="/speciality/update/:id" component={SpecialityEdit} />

            <PrivateRoute
              adminType="company"
              permission="sentences.view"
              exact
              path="/sentence"
              component={SentenceIndex}
            />
            <PrivateRoute
              adminType="company"
              permission="sentences.manage"
              exact
              path="/sentence/create"
              component={SentenceCreate}
            />

            <PrivateRoute
              adminType="company"
              permission="sentences.manage"
              path="/sentence/update/:sentenceId"
              component={SentenceUpdate}
            />

            <PrivateRoute
              adminType="company"
              permission="sentences.view"
              path="/sentence/:sentenceId"
              component={SentenceShow}
            />

            <PrivateRoute adminType="company" exact path="/download" component={AnalyticsInstallations} />

            <PrivateRoute adminType="company" exact path="/activity" component={AnalyticsConsultas} />

            <PrivateRoute adminType="company" exact path="/customer" component={AnalyticsCustomer} />

            <Route exact path="/responseTime" component={AnalyticsResponse} />

            <Route permission="quality-of-service.view" exact path="/qos" component={AnalyticsQos} />
            <PrivateRoute
              adminType="super-admin"
              permission="quality-of-service.view"
              exact
              path="/nps"
              component={AnalyticsNps}
            />
            <Route adminType="company" exact path="/usage" component={AnalyticsUsage} />
            <PrivateRoute
              adminType="super-admin"
              permission="companies.view"
              exact
              path="/companies"
              component={CompaniesIndex}
            />
            <PrivateRoute
              adminType="super-admin"
              permission="companies.view"
              exact
              path="/companies/create"
              component={CreateCompany}
            />

            <PrivateRoute
              adminType="super-admin"
              permission="companies.manage"
              exact
              path="/companies/update/:companyId"
              component={UpdateCompany}
            />
            <PrivateRoute
              adminType="super-admin"
              permission="companies.manage"
              exact
              path="/companies/specialities/:companyId"
              component={CompanySpecialities}
            />

            <PrivateRoute
              adminType="super-admin"
              permission="companies.manage"
              exact
              path="/companies/:companyId"
              component={UpdateCompany}
            />

            <PrivateRoute
              adminType="provider"
              permission="monitoring.view"
              exact
              path="/monitoring"
              component={Monitoring}
            />

            <PrivateRoute adminType="company" exact path="/derivations" component={DerivationIndex} />
            <PrivateRoute adminType="company" exact path="/derivations/create" component={DerivationCreate} />
            <PrivateRoute
              adminType="company"
              exact
              path="/derivations/update/:derivationId"
              component={DerivationUpdate}
            />
            <PrivateRoute adminType="company" exact path="/derivations/:derivationId" component={DerivationShow} />

            <PrivateRoute adminType="PaaS" exact path="/companies/update/:companyId" component={UpdateCompany} />

            <Route exact path="/forbidden" component={PageForbidden} />

            <Route path="*" component={PageNotFound} />

            {import.meta.env.VITE_REACT_APP_ENV !== 'PRODUCTION' && (
              <>
                <Route exact path="/dev/schedules" component={Schedules} />
              </>
            )}
          </Switch>
        </Dashboard>
      </Switch>
    </AuthenticationGate>
  </Switch>
)
